// project imports
import {
    processEntityInput as processEntityInputMain,
    processEntityOutput as processEntityOutputMain
} from 'store/serializers/fragments/main';
import { getIriFromObj } from 'utils/processors';

export const processEntityInput = (values) => ({ ...values, ...processEntityInputMain(values) });

export const processEntityOutput = (values) => ({
    ...values,
    ...processEntityOutputMain(values),
    workOrderType: 'workOrderType' in (values || {}) ? getIriFromObj(values.workOrderType) : undefined
});
